/*
 * Copyright 2018 Teralytics
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 */
import { rgbaAsString } from '@flowmap.gl/core';
import * as React from 'react';
var Disc = function (_a) {
    var size = _a.size, inner = _a.inner, outer = _a.outer, outline = _a.outline;
    return (React.createElement("svg", { width: size, height: size, style: { marginRight: 5 } },
        React.createElement("circle", { cx: size / 2, cy: size / 2, r: size * 0.5, fill: rgbaAsString(outline) }),
        React.createElement("circle", { cx: size / 2, cy: size / 2, r: size * 0.5 - 1, fill: rgbaAsString(outer) }),
        React.createElement("circle", { cx: size / 2, cy: size / 2, r: size * 0.5 * 0.6 - 1, fill: rgbaAsString(inner) })));
};
export default Disc;
//# sourceMappingURL=Disc.js.map